/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Col_DimensionInputs */

const en_directory_agent_readiness_col_dimension = /** @type {(inputs: Directory_Agent_Readiness_Col_DimensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimension`)
};

const zh_directory_agent_readiness_col_dimension = /** @type {(inputs: Directory_Agent_Readiness_Col_DimensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估维度`)
};

/**
* | output |
* | --- |
* | "Dimension" |
*
* @param {Directory_Agent_Readiness_Col_DimensionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_col_dimension = /** @type {((inputs?: Directory_Agent_Readiness_Col_DimensionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Col_DimensionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_col_dimension(inputs)
	return zh_directory_agent_readiness_col_dimension(inputs)
});
export { directory_agent_readiness_col_dimension as "directory.agent_readiness.col.dimension" }